import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TutorialStep, TutorialSection } from './tutorial-step.model';
import { TUTORIAL_SECTIONS } from './tutorial-content';

@Component({
  standalone: false,
  selector: 'app-forms-builder-tutorial',
  templateUrl: './forms-builder-tutorial.component.html',
  styleUrls: ['./forms-builder-tutorial.component.scss'],
})
export class FormsBuilderTutorialComponent implements OnInit {
  @ViewChild('tutorialMedia') mediaEl: ElementRef<HTMLVideoElement>;

  sections: TutorialSection[] = TUTORIAL_SECTIONS;
  allSteps: TutorialStep[] = [];
  currentStepIndex: number = 0;

  constructor(
    public dialogRef: MatDialogRef<FormsBuilderTutorialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { startSection?: 'finder' | 'editor'; startStepId?: string }
  ) {}

  ngOnInit(): void {
    this.allSteps = this.sections.reduce(
      (acc, section) => [...acc, ...section.steps],
      [] as TutorialStep[]
    );

    if (this.data?.startStepId) {
      const idx = this.allSteps.findIndex((s) => s.id === this.data.startStepId);
      if (idx >= 0) {
        this.currentStepIndex = idx;
        return;
      }
    }

    if (this.data?.startSection === 'editor') {
      const editorStartIndex = this.allSteps.findIndex(
        (s) => s.section === 'editor'
      );
      if (editorStartIndex >= 0) {
        this.currentStepIndex = editorStartIndex;
      }
    }
  }

  get currentStep(): TutorialStep | null {
    return this.allSteps[this.currentStepIndex] || null;
  }

  getCurrentSection(): TutorialSection | null {
    if (!this.currentStep) return null;
    return this.sections.find((s) => s.id === this.currentStep.section) || null;
  }

  getGlobalIndex(section: TutorialSection, localIndex: number): number {
    let offset = 0;
    for (const s of this.sections) {
      if (s.id === section.id) {
        return offset + localIndex;
      }
      offset += s.steps.length;
    }
    return localIndex;
  }

  goToStep(index: number): void {
    if (index >= 0 && index < this.allSteps.length) {
      this.currentStepIndex = index;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}

